export enum SystemActions {
  FETCH_SYSTEMS = "fetch systems",
  ASSIGN_USER_SYSTEMS = "assign user systems",
  SELECT_SYSTEM="select system",
  CREATE_SYSTEM="create system",
  DELETE_SYSTEM="delete system"
}